<template>
	<div>
		<span class="int_type" style="width:300px;">
			<AC ref="ac" :source="selectACItems" @selected="selectACItem" :resultsDisplay="resultsDisplay" placeholder="Item / Name or ID"> </AC>
		</span>
		<span class="int_type" style="width:140px;">
			<input type="text" :value="value" autocomplete="off" @focus="$event.target.select()" placeholder="Item Code" @input="emitChange($event.target.value)" />
		</span>
	</div>
</template>

<script>
import AC from '@/components/common/AC';
export default {
	props: {
		value: {
			type: String,
		},
		active_only: {
			type: Boolean,
			default: false,
		},
		resultsDisplay: {
			type: [String, Function],
			default: 'id_name',
		},
	},
	components: {
		AC,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
	},
	methods: {
		selectACItems(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_master/acItemList?company_id=' + this.user.company_id + '&active_only=' + this.active_only + '&keyword=' + input;
			return url;
		},
		selectACItem(i) {
			this.emitChange(i.selectedObject.item_code);
		},
		emitChange(str) {
			this.$emit('input', str);
		},
	},
};
</script>

<style></style>
